
// vendor libraries:
import React from 'react';
import ReactDOM from 'react-dom';
import type { Root } from 'react-dom/client';

import { createRoot } from 'react-dom/client';

//const strictMode = true; // DEBUG!!
const strictMode = false; // DEBUG!!
export function reactRender(element: React.ReactNode, container: ReactDOM.Container/*, callback*/) : Root {
    return reactReRender(undefined, element, container/*, callback*/);
}

export function reactReRender(root: Root, element: React.ReactNode, container: ReactDOM.Container/*, callback*/): Root {
    if(!root)
        root = createRoot(container/*, callback*/);
    if (strictMode)
        root.render(React.createElement(React.StrictMode, {}, element));
    else
        root.render(element);
    return root;
}
